export const AI_SCREENER_CODES = new Set([
  'MOMENTUM_AI',
  'POSITIVE_GAP_UP',
  'BREAKOUT_AI',
  'TREND_CONTINUATION',
  'ROCKET_LAUNCH_AI',
]);

export const isAIScreener = (code?: string): boolean =>
  !!code && AI_SCREENER_CODES.has(code);
